import { redoDiscountSchema } from "@redotech/redo-discounts-common/discount/discount-db-parser";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getDiscount = {
  name: "getDiscount" as const,
  input: z.object({ _id: zExt.objectId() }),
  output: redoDiscountSchema,
};
